/**
 * Shared by the top-bar availability menus, which unmount when their dropdown closes: a request
 * still running keeps the items disabled when the menu opens again.
 */
export const SET_USER_AWAY_MUTATION_KEY = 'topBarSetUserAway';
